import { Checkbox, HStack, StackProps } from "@chakra-ui/react";
import { useMemo } from "react";
import { SeriesListItem } from "@/components/contest/seriesListItem";
import { ISeriesListItem } from "@/models/seriesListItem";
import {
  useGetEntrySeriesIds,
  useUpdateSeriesId,
} from "@/state/entry-series-state";

type Props = {
  item: ISeriesListItem;
} & StackProps;

export const EntryItem = ({ item, ...stackProps }: Props) => {
  const seriesIds = useGetEntrySeriesIds();
  const { addEntry, removeEntry } = useUpdateSeriesId();

  const checked = useMemo(() => {
    return seriesIds.includes(item.id);
  }, [item.id, seriesIds]);

  return (
    <HStack
      w="full"
      gap={3}
      px={4}
      cursor="pointer"
      bg={checked ? "backgroundLinkSecondary" : "backgroundPrimary"}
      {...stackProps}
    >
      <Checkbox.Root
        colorPalette="blue"
        size="md"
        variant="solid"
        w="full"
        cursor="pointer"
        checked={checked}
        onCheckedChange={(e) => {
          if (!!e.checked) {
            addEntry(item.id);
          } else {
            removeEntry(item.id);
          }
        }}
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control
          _checked={{
            bg: "backgroundLinkPrimary",
            borderColor: "transparent",
          }}
          borderColor="#989BA1"
          borderWidth={2}
          borderRadius={4}
        />
        <Checkbox.Label>
          <SeriesListItem item={item} w="full" flex={1} px={0} bg={undefined} />
        </Checkbox.Label>
      </Checkbox.Root>
    </HStack>
  );
};
